import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { ModalBaseComponent } from '../../core/components/modal-base.component';
import { ToastService } from '../../toast';

/**
 * Context used by {@link ModalTemplateComponent} to render a generic alert/confirm dialog.
 *
 * Note: `title`/`message`/`okButtonText`/`cancelButtonText` are expected to already be
 * translated (resolved plain strings) by the time they reach this component — `ModalService`
 * (and `U2000_ModalProvider`) translate them before opening the dialog, matching the existing
 * behavior of this app (unlike adsu2, which resolves translation keys directly in this
 * template via the `translate` pipe).
 */
export interface IModalTemplateContext extends ModalOptions {
    title: string;
    message: string;
    okButtonText: string;
    cancelButtonText: string;
    hideCancelButton: boolean;
}

@Component({
    selector: 'modal-template',
    templateUrl: 'modal-template.component.html',
    styleUrls: ['modal-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ModalTemplateComponent extends ModalBaseComponent<any, boolean> implements IModalTemplateContext {
    title: string;
    message: string;
    okButtonText: string;
    cancelButtonText: string;
    hideCancelButton: boolean;

    constructor(
        public dialog: BsModalRef,
        toastService: ToastService,
    ) {
        super(null, toastService);
    }

    closeClick() {
        this.dialog.hide();
    }

    confirmClick() {
        this.result = true;
        this.dialog.hide();
    }
}
